type RpBreakpoint = 'mobile' | 'tablet' | 'desktop'

type CardSize = {
  width: number
  height: number
}

type ResponsiveCardSize = Record<RpBreakpoint, CardSize>
type ResponsiveNumber = Record<RpBreakpoint, number>

export const DETAIL_CARD_SIZE: ResponsiveCardSize = {
  mobile: { width: 25, height: 39 },
  tablet: { width: 45, height: 71 },
  desktop: { width: 45, height: 71 },
}

export const DETAIL_CARD_GAP: ResponsiveNumber = {
  mobile: 6,
  tablet: 6,
  desktop: 8,
}

const calcDetailRowWidth = (cardsCount: number): ResponsiveNumber => ({
  mobile:
    cardsCount * DETAIL_CARD_SIZE.mobile.width +
    (cardsCount - 1) * DETAIL_CARD_GAP.mobile,
  tablet:
    cardsCount * DETAIL_CARD_SIZE.tablet.width +
    (cardsCount - 1) * DETAIL_CARD_GAP.tablet,
  desktop:
    cardsCount * DETAIL_CARD_SIZE.desktop.width +
    (cardsCount - 1) * DETAIL_CARD_GAP.desktop,
})

export const DETAIL_ROW_WIDTH = {
  fiveCards: calcDetailRowWidth(5),
  sixCards: calcDetailRowWidth(6),
}

export const DECISION_BUTTONS_MIN_HEIGHT: ResponsiveNumber = {
  mobile: 24,
  tablet: 44,
  desktop: 50,
}

export const DECISION_BUTTONS_VERTICAL_PADDING = 12

export const DECISION_BUTTONS_MIN_TOTAL_HEIGHT: ResponsiveNumber = {
  mobile: DECISION_BUTTONS_MIN_HEIGHT.mobile + DECISION_BUTTONS_VERTICAL_PADDING,
  tablet: DECISION_BUTTONS_MIN_HEIGHT.tablet + DECISION_BUTTONS_VERTICAL_PADDING,
  desktop:
    DECISION_BUTTONS_MIN_HEIGHT.desktop + DECISION_BUTTONS_VERTICAL_PADDING,
}
